module.exports = __webpack_public_path__ + "static/image7-871ee61bed311ccd5285935e07680df2.jpeg";